// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__L3kQV","colMaxWidth":"Table_colMaxWidth__2VnsC"};